interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

// TODO: use from icons library when available
export const ArrowLeftIcon = (props: IconProps): JSX.Element => {
    const { width = "36", height = "36", className } = props;
    return (
        <svg className={className} width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 18L5.29289 17.2929L4.58579 18L5.29289 18.7071L6 18ZM28.5 19C29.0523 19 29.5 18.5523 29.5 18C29.5 17.4477 29.0523 17 28.5 17V19ZM14.2929 8.29289L5.29289 17.2929L6.70711 18.7071L15.7071 9.70711L14.2929 8.29289ZM5.29289 18.7071L14.2929 27.7071L15.7071 26.2929L6.70711 17.2929L5.29289 18.7071ZM6 19H28.5V17H6V19Z"
                fill="#FF4E00"
            />
        </svg>
    );
};

export default ArrowLeftIcon;
